"use strict";
import apiUrl from './constants'
import axios from 'axios'
export default { getRestApiResponse, calculateImageSize,logout }

function getRestApiResponse(method, apiName, payload, alertify) {
    return new Promise((resolve, reject) => {
        var userToken = window.localStorage.getItem('userToken');
        var myStr = userToken.replace(/"/g, '');

        axios({
            method: method,
            'url': apiUrl.api_url + apiName,
            'data': payload,
            headers: {
                'Authorization': 'Bearer ' + myStr,
            }
        })
            .then(result => {
                resolve(result)

            }, error => {
                alertify.error("" + error)
                error.errorDATA = true
                resolve(error)
            });
    })
}
function calculateImageSize(imageString) {
    let stringLength = imageString.length - 'data:image/png;base64,'.length;
    let sizeInBytes = 4 * Math.ceil((stringLength / 3)) * 0.5624896334383812;
    let sizeInKb = sizeInBytes / 1000;
    console.log(sizeInKb, "sizeInKb");
    if (sizeInKb < 4000)
        return true
    else
        return false

}
function logout() {
    localStorage.removeItem('permissiondata')
    localStorage.removeItem('userdetail')
    localStorage.removeItem('userToken')
    localStorage.removeItem('refreshToken')
    localStorage.removeItem('isLoggedIn')
    localStorage.removeItem('clientList')
    localStorage.removeItem('warehouseList')
    localStorage.removeItem('innerpermissiondata')
    localStorage.removeItem('hasReloaded')
    localStorage.removeItem('slaconfig')
    localStorage.removeItem('locale')
    localStorage.setItem("keyclockloginpage", false);
    localStorage.setItem('keycloakInitialized',false);
    localStorage.setItem('islogout',true)
    window.location.href = window.location.origin+"/#/login"
  }



// WEBPACK FOOTER //
// ./src/common_helper.js